import { render, staticRenderFns } from "./CapitalInfo.vue?vue&type=template&id=a0627d10&scoped=true&"
import script from "./CapitalInfo.vue?vue&type=script&lang=js&"
export * from "./CapitalInfo.vue?vue&type=script&lang=js&"
import style0 from "./CapitalInfo.vue?vue&type=style&index=0&id=a0627d10&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0627d10",
  null
  
)

export default component.exports